function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Select } from "./";
import api from "../../services/api";
import object from "../../services/utils/object";
import getResource from "../../services/resources";
import { connect } from 'formik';
export default connect( /*#__PURE__*/function (_React$Component) {
  _inherits(Resource, _React$Component);

  var _super = _createSuper(Resource);

  function Resource() {
    var _this;

    _classCallCheck(this, Resource);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      collection: [],
      loading: false
    });

    return _this;
  }

  _createClass(Resource, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.autocomplete) {
        this.fetch();
      }
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var _this2 = this;

      this.setState({
        loading: false
      });
      var _this$props = this.props,
          resource = _this$props.resource,
          filters = _this$props.filters,
          formik = _this$props.formik;
      var id = resource + JSON.stringify(filters);

      if (formik.referencials && formik.referencials[id]) {
        return this.setState({
          collection: formik.referencials[id],
          loading: false
        });
      }

      var promise = Promise.resolve({});

      if (resource) {
        promise = getResource(resource).list(filters);
      } else {
        if (formik.mapping) {
          var mappingEntrypoint = formik.mapping.getEntrypoint(this.props.name);

          if (mappingEntrypoint) {
            promise = api.get(mappingEntrypoint, filters).then(function (_ref) {
              var data = _ref.data;
              return data;
            });
          }
        }
      }

      promise.then(function (data) {
        _this2.setState({
          collection: data['hydra:member'] || [],
          loading: false
        }, function () {
          formik.setFormikState(_objectSpread(_objectSpread({}, formik), {}, {
            referencials: _objectSpread(_objectSpread({}, formik.referencials), {}, _defineProperty({}, id, data['hydra:member'] || []))
          }));
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this$props2 = this.props,
          name = _this$props2.name,
          formik = _this$props2.formik,
          useId = _this$props2.useId,
          targetProperty = _this$props2.targetProperty,
          multiple = _this$props2.multiple;

      var _ref2 = formik.getFieldProps(name) || {},
          value = _ref2.value;

      var fieldValue = multiple ? value : [value];
      var realFieldValue = [];

      if (Array.isArray(fieldValue)) {
        for (var i = 0, len = fieldValue.length; i < len; ++i) {
          if (fieldValue[i] && _typeof(fieldValue[i]) === 'object') {
            realFieldValue.push(targetProperty ? fieldValue[i][targetProperty] : fieldValue[i][useId ? 'id' : '@id']);
          } else {
            realFieldValue.push(fieldValue[i]);
          }
        }
      }

      realFieldValue = multiple ? realFieldValue : realFieldValue[0];

      if (JSON.stringify(value) !== JSON.stringify(realFieldValue)) {
        realFieldValue !== null && this.props.formik.setFieldValue(name, realFieldValue);
      }

      if (realFieldValue === null) {
        return this.props.formik.setFieldValue(name, undefined);
      }
    }
  }, {
    key: "buildOptions",
    value: function buildOptions() {
      var _this3 = this;

      var _this$props3 = this.props,
          useId = _this$props3.useId,
          targetProperty = _this$props3.targetProperty;
      return this.state.collection.map(function (item) {
        var option = {
          value: targetProperty ? item[targetProperty] : item[useId ? 'id' : '@id'],
          label: item.id
        };
        var display = _this3.props.display;

        if (typeof display === 'string') {
          option.label = object.get(display, item);
        } else if (typeof display === 'function') {
          option.label = display(item);
        }

        return option;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var loading = this.state.loading;

      var _this$props4 = this.props,
          display = _this$props4.display,
          resource = _this$props4.resource,
          filters = _this$props4.filters,
          entrypoint = _this$props4.entrypoint,
          inputTag = _this$props4.inputTag,
          formik = _this$props4.formik,
          props = _objectWithoutProperties(_this$props4, ["display", "resource", "filters", "entrypoint", "inputTag", "formik"]);

      var InputTag = inputTag || Select;
      return /*#__PURE__*/React.createElement(InputTag, _extends({
        isLoading: loading,
        isDisabled: loading,
        options: this.buildOptions()
      }, props));
    }
  }]);

  return Resource;
}(React.Component));